import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error Untyped actions
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import { getContentTypeLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MlangLimitUpgradeModal = () => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(closeModal());
  const onConfirm = () => {
    window.location.href = ContentRoutes.cmsHubPricingPage();
  };
  const contentTypeLimit = useSelector(getContentTypeLimit);
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "mlang-limit-alert-modal",
    size: "auto",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "limitExceededError.mlangLimitModal.title",
          options: {
            count: contentTypeLimit.mlangPostQuantityUsed,
            mlangLimit: contentTypeLimit.mlangPostLimit
          }
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "limitExceededError.mlangLimitModal.message"
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "mlang-limit-alert-modal-confirm",
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "limitExceededError.mlangLimitModal.starter"
        })
      })
    })]
  });
};
export default MlangLimitUpgradeModal;